import { isNull, isUndefined, set } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { initialNumberFilter } from '../../../../constants/instanceFilters';
import { Comparator, NumberFilterType } from '../../store/filterTypes';
import { ComparatorFilter } from './ComparatorFilter';
import { SharedNumberFilter } from './SharedNumberFilter';
import styles from './TableInstanceFilters.module.scss';

interface NumberFilterProps {
    updateFilter: (value: NumberFilterType) => void;
    removeFilter: () => void;
    filter: NumberFilterType | null;
    testId: string;
}

export const NumberFilter: React.FC<NumberFilterProps> = ({ updateFilter, removeFilter, filter, testId }) => {
    const numberFilter = useMemo(() => isNull(filter) ? initialNumberFilter : filter, [filter]);
    const { comparator, value } = numberFilter;

    const updateNumberFilter = useCallback((key: keyof NumberFilterType, value: number | Comparator | undefined | null) => {
        if ((key === 'value' && isUndefined(value)) || (key === 'comparator' && isNull(value) && isUndefined(numberFilter.value))) {
            removeFilter();
            return;
        }
        const updatedFilter = set(key, value, numberFilter);
        updateFilter(updatedFilter);
    }, [removeFilter, updateFilter, numberFilter]);

    const updateComparatorFilter = useCallback((value: Comparator | null) => updateNumberFilter('comparator', value), [updateNumberFilter]);

    const updateNumberValue = useCallback((value: number | undefined) => updateNumberFilter('value', value), [updateNumberFilter]);

    return (
        <div className={styles.comparatorSplitWrapper}>
            <ComparatorFilter updateFilter={updateComparatorFilter} filter={comparator} testId={testId} />
            <SharedNumberFilter updateFilter={updateNumberValue} filter={value} testId={testId} />
        </div>
    );
};
